<template>
  <div class="container">
    <h1>
      <a href="http://www.spr-atm.com/"><img class="logo" src="../../assets/logo.png" alt="logo"></a>
    </h1>
    <div class="menu-wrapper">
      <el-menu ref="menu" mode="horizontal" :default-active="currentIndex" class="menus" :router="true">
        <template v-for="menu in Menus">
          <el-submenu v-if="menu.children && (Customer.isPrimaryAccount ? true:PermissionJson.find((n) => n === menu.index))" class="menu" :data-index="menu.index" :key="menu.index" :index="menu.index" @mouseenter.native.self="handleMouseEnter" @mouseleave.native.self="handleMouseOut">
            <template slot="title">{{menu.title}}</template>
            <el-menu-item v-for="submenu in menu.children" :key="submenu.index" :index="submenu.index">
              <span>{{submenu.title}}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-if="!menu.children && (Customer.isPrimaryAccount ? true:PermissionJson.find((n) => n === menu.index))" class="menu" :data-index="menu.index" :key="menu.index" :index="menu.index" @mouseenter.native.self="handleMouseEnter" @mouseleave.native.self="handleMouseOut">
            <span>{{menu.title}}</span>
          </el-menu-item>
        </template>
      </el-menu>
      <div class="menu-hover-bar" :style="barStyle"></div>
    </div>
    <div class="user-panel">
      <div class="logined">
        您好！
        <span class="username">{{Customer.userName}}</span>
        <el-button class="logout-btn" type="text" @click="handleLogout">退出</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import o from '@/odata'
export default {
  data() {
    return {
      Menus: [
        {index: '/', title: '首页'},
        {
          index: '/entrust',
          title: '委托查询',
          children: [
            {index: '/entrust', title: '委托订单列表'},
            {index: '/entrust_lease', title: '租赁收入列表'},
            {index: '/entrust_sell', title: '出售收入列表'},
          ],
        },
        {
          index: '/lease',
          title: '租赁查询',
          children: [
            { index: '/lease', title: '租赁订单查询' },
            { index: '/leaseprice', title: '租赁价格查询' },
          ],
        },
        {
          index: '/inventory',
          title: '库存查询',
          children: [
            { index: '/trust', title: '委托库查询' },
            { index: '/managed', title: '代管库查询' },
          ],
        },
        {
          index: '/repair',
          title: '维修查询',
          children: [
            { index: '/repair', title: '维修订单列表' },
            { index: '/repairprice', title: '维修价格查询' },
          ],
        },
        { index: '/logistics',
          title: '物流信息查询',
          children: [
            { index: '/leaseSend', title: '发货单列表' },
            { index: '/logistics', title: '物流订单列表' },

          ],
        },
        {
          index: '/financial',
          title: '结算查询',
          children: [
            { index: '/entrustedIncome_statement', title: '租赁收益报表' },
            { index: '/entrustedSale_statement', title: '销售收入报表' },
            { index: '/repairExpenditure_statement', title: '维修支出报表' },
            { index: '/logisticsExpenditure_statement', title: '物流支出报表' },
            { index: '/LeaseExpenditure_statement', title: '租赁支出报表' },
            { index: '/deposit_statement', title: '保证金报表' },
            { index: '/escrowExpenditure_statement', title: '代管库支出报表' },
          ],
        },
        {
          index: '/order',
          title: '订单管理',
          children: [
            { index: '/leaseSent_order', title: '发货通知单' },
            { index: '/purchase_order', title: '采购询价单' },
            { index: '/entrust_order', title: '委托申请单' },
            { index: '/dispatch_order', title: '调度申请单' },
          ],
        },
        {
          index: '/profile/info',
          title: '个人中心',
        },
      ],
      barStyle: {
        left: 0,
        width: 0,
        opacity: 0,
      },
      PermissionJson: [], // 权限数组
    }
  },
  computed: {
    currentIndex() {
      return this.$route.path
    },
    Customer() {
      return JSON.parse(window.localStorage.getItem('CURRENT_USER'))
    },
  },
  methods: {
    handleMouseEnter(e) {
      this.$set(this, 'barStyle', {
        left: (e.target.offsetLeft + 30) + 'px',
        width: e.target.clientWidth + 'px',
        opacity: 1,
      })
    },
    handleMouseOut(e) {
      this.$set(this, 'barStyle', {
        left: ((e.target.offsetLeft + 30) + (e.target.clientWidth / 2)) + 'px',
        width: 0,
        opacity: 0,
      })
    },
    handleLogout() {
      window.localStorage.clear()
      window.location.href = '#/login'
      window.setTimeout(() => {
        window.location.reload()
      })
    },
    getUserPermission () {
      const user = this.Customer.customer
      if (!user) {
        o('PartnerAccount').filter(`PartnerId eq ${user.customerId}`).first().get().then(({data}) => {
          this.PermissionJson = JSON.parse(data.PermissionJson)
        })
      } else {
        this.PermissionJson = JSON.parse(user.permissions)
      }
    },
  },
  created() {
    this.getUserPermission()
  },
}
</script>

<style lang="less" scoped>
.el-submenu .el-menu-item{
  min-width:110px;
}
.logo {
  // width: 176px;
  vertical-align: middle;
}

.container {
  position: relative;
}

h1 {
  float: left;
  margin: 0;
}

.menu-wrapper {
  display: inline-block;
  position: relative;
  .menu-hover-bar {
    position: absolute;
    background: #00aeef;
    color: #00aeef;
    height: 2px;
    bottom: 0;
    opacity: 0;
    transition: all .2s;
  }
}

.menus {
  color: #fff;
  float: left;
  height: 100%;
  background: transparent;
  padding: 0;
  margin: 42px 0 0 30px;
}

.user-panel {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 40px;
  .username {
    color: #50bfff;
  }
  .logout-btn {
    color: #fff;
    font-size: 14px;
  }
}
</style>

<style lang="less">
.el-menu--horizontal>.menu.el-menu-item,
.el-menu--horizontal .menu.el-submenu {
  color: #fff;
  padding: 0;
  // padding: 40px 0;
  height: inherit;
  border-bottom: none; // font-weight: 800;
  font-size: 14px; // width: 76px;
  text-align: center;
  >span,
  >.el-submenu__title {
    position: relative;
    color: #fff; // font-weight: 800;
    font-size: 14px;
    display: block;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    border-radius: 4px;
  }
  >.el-submenu__title {
    transition: none;
    &>.el-submenu__icon-arrow {
      display: none;
    }
  }
  .el-menu {
    top: 48px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border: none;
    .el-menu-item span {
      background: transparent;
      color: #333;
    }
    .el-menu-item:hover {
      // background-color: #c5e1f7;
      span {
        color: #20a0ff;
        background: transparent;
      }
    }
  }
  &:hover {
    border-bottom: none;
    background: transparent;
    span {
      // background-color: #fff;
      // color: #5d5d5d;
    }
    .el-submenu__title {
      background-color: transparent; // color: #5d5d5d;
      border-bottom: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  &.is-active>span:after,
  &.is-active>.el-submenu__title:after {
    position: absolute;
    content: ' ';
    height: 2px;
    background: #00aeef;
    color: #00aeef;
    left: 0;
    bottom: 0;
    width: 100%;
  }
}

.el-menu--horizontal>.menu.el-submenu.is-active .el-submenu__title {
  border-bottom: none; // background: #fff;
  // color: #43484d;
}
</style>



// WEBPACK FOOTER //
// Header.vue?cc9953a8